<template>
  <div>
    <!-- Barra Principal -->
    <v-app-bar
      id="toolbar"
      app
      :color="`primary ${$vuetify.theme.dark ? 'darken-1' : ''}`"
      dark
    >
      <!-- Botão de Opções -->
      <v-app-bar-nav-icon @click.stop="drawer = !drawer" />

      <!-- Logo -->
      <div class="d-flex align-center">
        <v-img
          alt="Logo Gestão por Competências"
          class="shrink mr-2"
          style="cursor: pointer"
          contain
          src="/static/images/desenvolva/desenvolva3.png"
          transition="scale-transition"
          width="140"
          @click="$router.push('/inicio')"
        />
      </div>

      <v-spacer />

      <!-- Nome do Usuário, Foto e Informação de Sessão -->
      <p class="font-weight-light body-2 hidden-sm-and-down pt-4 px-2">
        {{ usuario.nome }}<br>
        <span class="font-weight-light caption secondary--text text--lighten-2">
          Sua sessão expira às {{ fimSessao }}
        </span>
      </p>
      <!-- Menu com opções da conta -->
      <v-menu
        :nudge-bottom="10"
        offset-y
        origin="center center"
        transition="scale-transition"
      >
        <!-- Foto -->
        <template v-slot:activator="{ on }">
          <v-btn
            class="hidden-xs-only"
            icon
            large
            text
            v-on="on"
          >
            <v-avatar size="30px">
              <v-icon>account_circle</v-icon>
            </v-avatar>
          </v-btn>
        </template>

        <!-- Opções da Conta -->
        <v-list>
          <!-- Perfil -->
          <v-list-item @click="to('/perfil/cadastrar')">
            <v-list-item-icon>
              <v-icon>person</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Meu Perfil</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <!-- Sair -->
          <v-list-item @click="to('/logout')">
            <v-list-item-icon>
              <v-icon color="error">
                power_settings_new
              </v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="error--text">
                Sair
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>

    <!-- Menu Lateral -->
    <v-navigation-drawer
      v-model="drawer"
      class="sigec-drawer"
      fixed
      temporary
    >
      <div class="d-flex flex-column fill-height">
        <v-list>
          <!-- Nome, Foto, Informação de Sessão --->
          <v-list-item>
            <v-list-item-avatar>
              <v-icon size="50px">
                account_circle
              </v-icon>
            </v-list-item-avatar>

            <v-list-item-content>
              <v-list-item-title class="body-1 primary--text nome-menu-lateral">
                {{ usuario.nome }}
              </v-list-item-title>
              <v-list-item-subtitle>
                <span
                  class="caption"
                >Sua sessão expira às {{ fimSessao }}</span>
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>

        <v-divider />

        <!-- Links, Modo Escuro, Ocultar, Sair -->
        <v-list
          class="d-flex flex-column"
          dense
          height="100%"
          nav
        >
          <!-- Links para os módulos -->
          <v-list-item
            v-for="item in menuItens"
            :key="item.link"
            :to="item.link"
            class="sigec-list-item primary--text"
          >
            <v-list-item-icon>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-title>{{ item.nome }}</v-list-item-title>
          </v-list-item>

          <!-- Modo Escuro -->
          <v-list-item
            class="mt-auto sigec-list-item"
            @click="toogleModoEscuro"
          >
            <v-list-item-icon>
              <v-icon>
                contrast
              </v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title :class="$vuetify.theme.dark ? '' : 'grey--text text--darken-2'">
                {{ $vuetify.theme.dark ? 'Modo Claro' : 'Modo Escuro' }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <!-- Ocultar -->
          <v-list-item
            class="sigec-list-item"
            @click.stop="drawer = !drawer"
          >
            <v-list-item-icon>
              <v-icon color="warning">
                keyboard_double_arrow_left
              </v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="warning--text">
                Ocultar Menu
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <!-- Sair -->
          <v-list-item
            class="mb-2 sigec-list-item"
            @click.stop="to('/logout')"
          >
            <v-list-item-icon>
              <v-icon color="error">
                power_settings_new
              </v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="error--text">
                Sair
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </div>
    </v-navigation-drawer>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'AppToolbar',

  data() {
    return {
      nome: '',
      drawer: false,
      menuItens: [
        { nome: 'Início', link: '/inicio', icon: 'home' },
        { nome: 'Perfil', link: '/perfil', icon: 'person' },
        { nome: 'Mapeamento', link: '/mapeamento', icon: 'widgets' },
        { nome: 'Diagnóstico', link: '/diagnostico', icon: 'how_to_reg' },
        { nome: 'Desempenho', link: '/desempenho', icon: 'trending_up' },
      ],
    };
  },

  computed: {
    ...mapState({
      usuario: (state) => state.auth.usuario,
      comissao: (state) => state.auth.comissao,
      chefia: (state) => state.auth.chefia,
      substituicaoChefia: (state) => state.auth.substituicaoChefia,
      fimSessao: (state) => state.app.fimSessao,
    }),
  },

  created() {
    if (this.comissao || this.chefia || this.substituicaoChefia) {
      this.menuItens.push({ nome: 'Monitoramento', link: '/monitoramento', icon: 'poll' });
    }
    if (this.comissao) {
      this.menuItens.push({ nome: 'Gerenciamento', link: '/gerenciamento', icon: 'list_alt' });
    }
  },

  methods: {
    to(path) {
      this.$router.push(path);
    },
    toogleModoEscuro() {
      // Troca tema escuro
      this.$vuetify.theme.dark = !this.$vuetify.theme.dark;

      // Armazena config do modo escuro no armazenamento local
      window.localStorage.setItem('dark', this.$vuetify.theme.dark);
    },
  },
};
</script>

<style lang="css" scoped>
#logo {
  max-width: 45px;
}

#toolbar {
  z-index: 10;
}

.sigec-drawer {
  top: 56px !important;
  height: calc(100% - 56px) !important;
  width: 275px !important;
}

.sigec-list-item {
  flex: 0;
  text-transform: uppercase;
}

.nome-menu-lateral {
  text-overflow: initial;
  white-space: initial;
}
</style>
